import groupTermsBy from './groupTermsBy';
import Term from '../Term';

/**
 * ToSentences does the following:
 * 1) groups terms  and series of terms by whether or not they are puct
 *     --- [[word], [punct], [word, word, word,word], [punct] ....]
 * 2) merges each punct with the word series before it.
 * 3) returns each word series as the child of a single term, 'by sentence'
 *
 * note this doesn't guarantee that each word group HAS punctuation. If the series
 * is all words, or the last word is not punct, then the last (or maybe only) series might not have
 * a punct.
 *
 * @param source
 * @returns {Term}
 */
function toSentences(source) {
  if (!Array.isArray(source)) throw new Error('mergePunct passed non-array');

  const byIsPunct = groupTermsBy(source, (term) => (
    term && term.isMeta && term.meta === 'punc' && term.value === '.'
  ));

  byIsPunct.forEach((group, index) => {
    if (index && group.key) {
      const prevGroup = byIsPunct[index - 1];
      if (prevGroup) {
        prevGroup.push(group, true);
        // merge the punctuation content onto the previous group, emptying it.
      }
    }
  });

  const sValue = _(byIsPunct).reject('key').map('terms')
    .map((value) => new Term({ props: { type: 'sentence' }, value }))
    .value();

  return new Term({ props: { type: 'by sentence' }, value: sValue });
}

export default toSentences;
